"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_VIEW_ONLY_ROUTES = exports.DEFAULT_ROUTES = exports.DEFAULT_ADMIN_ROUTES = void 0;
var DEFAULT_ADMIN_ROUTES = [{
  name: 'adminDashboard',
  route: '/admin-dashboard',
  isLogin: true
}, {
  name: 'adminZones',
  route: '/admin-zones',
  isLogin: true
}, {
  name: 'customer',
  route: '/customer',
  isLogin: true
}];
exports.DEFAULT_ADMIN_ROUTES = DEFAULT_ADMIN_ROUTES;
var DEFAULT_ROUTES = [{
  isParent: true,
  name: 'dashboard',
  children: [{
    name: 'orderDashboard',
    route: '/dashboard',
    isLogin: true
  }, {
    permission: ['lastMileDelivery', 'lastMileV2', 'lastMileDeliveryWellcome', 'lastMileDeliveryPricerite'],
    name: 'carrierDashboard',
    route: '/dashboard/carrier',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['data'],
  name: 'data',
  children: [{
    name: 'dataZone',
    route: '/data/zone',
    isLogin: true
  }, {
    name: 'dataLocation',
    route: '/data/location',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['lastMileDelivery'],
  name: 'lastMileDelivery',
  children: [{
    name: 'lmdDashboard',
    route: '/last-mile-delivery/main-dashboard',
    isLogin: true
  }, {
    name: 'lmdManualAssign',
    route: '/last-mile-delivery/manual-assign',
    isLogin: true
  }, {
    name: 'lmdAutoAssign',
    route: '/last-mile-delivery/auto-assign',
    isLogin: true
  }, {
    name: 'lmdLogs',
    route: '/last-mile-delivery/logs',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['lastMileV2'],
  name: 'lastMileV2',
  children: [{
    name: 'lmdV2Dashboard',
    route: '/last-mile-v2/main-dashboard',
    isLogin: true
  }, {
    name: 'lmdV2Logs',
    route: '/last-mile-v2/main-logs',
    isLogin: true
  }, {
    name: 'lmdV2ManualAssign',
    route: '/last-mile-v2/manual-assign',
    isLogin: true
  }, {
    name: 'lmdV2AutoAssign',
    route: '/last-mile-v2/auto-assign',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['lastMileDeliveryPricerite'],
  name: 'lastMileDeliveryPricerite',
  children: [{
    name: 'lmdPriceriteDashboard',
    route: '/last-mile-delivery/pricerite/main-dashboard',
    isLogin: true
  }, {
    name: 'lmdPriceriteManualAssign',
    route: '/last-mile-delivery/pricerite/manual-assign',
    isLogin: true
  }, {
    name: 'lmdPriceriteAutoAssign',
    route: '/last-mile-delivery/pricerite/auto-assign',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['lastMileDeliveryWellcome'],
  name: 'lastMileDeliveryWellcome',
  children: [{
    name: 'lmdWellcomeDashboard',
    route: '/last-mile-delivery/wellcome/main-dashboard',
    isLogin: true
  }, {
    name: 'lmdWellcomeManualAssign',
    route: '/last-mile-delivery/wellcome/manual-assign',
    isLogin: true
  }, {
    name: 'lmdWellcomeAutoAssign',
    route: '/last-mile-delivery/wellcome/auto-assign',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['milkRun'],
  name: 'milkRun',
  children: [{
    name: 'mrDashboard',
    route: '/milk-run/main-dashboard',
    isLogin: true
  }, {
    name: 'mrLatenessDashboard',
    route: '/milk-run/lateness-dashboard',
    isLogin: true
  }, {
    name: 'mrSummaryDashboard',
    route: '/milk-run/summary-dashboard',
    isLogin: true
  }, {
    name: 'mrManualAssign',
    route: '/milk-run/manual-assign',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['milkRunV2'],
  name: 'milkRunV2',
  children: [{
    name: 'mr2Dashboard',
    route: '/milk-run-v2/main-dashboard',
    isLogin: true
  }, {
    name: 'mr2Logs',
    route: '/milk-run-v2/logs',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['railway'],
  name: 'railway',
  children: [{
    name: 'railwayDashboard',
    route: '/railway/main-dashboard',
    isLogin: true
  }, {
    name: 'railwayManualAssign',
    route: '/railway/manual-assign',
    isLogin: true
  }],
  hideChildren: true
}, {
  isParent: true,
  permission: ['report'],
  name: 'report',
  children: [{
    permission: ['lastMileDelivery'],
    name: 'lmdLoadPlanReport',
    route: '/report/lmd-load-plan',
    isLogin: true
  }, {
    permission: ['lastMileDelivery'],
    name: 'lmdTruckSummaryReport',
    route: '/report/lmd-truck-summary',
    isLogin: true
  }, {
    permission: ['milkRun'],
    name: 'mrSummaryReport',
    route: '/report/milk-run-summary',
    isLogin: true
  }, {
    permission: ['railway'],
    name: 'railwaySummaryReport',
    route: '/report/railway-summary',
    isLogin: true
  }],
  hideChildren: true
}];
exports.DEFAULT_ROUTES = DEFAULT_ROUTES;
var DEFAULT_VIEW_ONLY_ROUTES = ['dashboard', 'lastMileDelivery', 'lastMileDeliveryPricerite', 'lastMileDeliveryWellcome', 'lastMileV2', 'milkRun', 'milkRunV2', 'railway', 'report', 'orderDashboard', 'lmdDashboard', 'lmdV2Dashboard', 'lmdPriceriteDashboard', 'lmdWellcomeDashboard'];
exports.DEFAULT_VIEW_ONLY_ROUTES = DEFAULT_VIEW_ONLY_ROUTES;